import {
    CursorBasedPaginationRequest,
    CursorBasedPaginationResponse,
    QueryBaseTypeWithCursorPaginationWhereAndOrder,
} from 'api/common';
import {REMINDER_TYPE, REMINDER_OBJECT_TYPE} from './reminder-enum';

export type ReminderModel = {
    __typename?: string;
    active: boolean;
    createdBy?: string;
    createdDate?: Date | string;
    description: string;
    id: string;
    isCompleted: boolean;
    lastModifiedDate?: Date | string;
    modifiedBy?: string;
    reminderDate: Date | string;
    status: string;
    title: string;
    objectId?: string | null;
    type: REMINDER_TYPE;
    objectType?: REMINDER_OBJECT_TYPE;
    url?: string;
    ticketNo?: number;
    //   user?: UserInfo;
    userId: string;
};

export interface ReminderCreateRequestModelInput {
    title: string;
    description?: string;
    reminderDate: Date;
    status: string;
    type: REMINDER_TYPE;
    objectId?: string | null;
    objectType?: REMINDER_OBJECT_TYPE;
    userId: string;
}
export interface ReminderCreateRequestModelInputBindingModel
    extends Omit<ReminderCreateRequestModelInput, 'reminderDate'> {
    reminderDate: string;
}
export type ReminderUpdateRequestModelInput = ReminderCreateRequestModelInput & {
    id: string;
};
export interface ReminderUpdateRequestModelInputModel extends Omit<ReminderUpdateRequestModelInput, 'reminderDate'> {
    reminderDate: string;
    id: string;
}

export type ReminderCreateUpdateRequestModel = ReminderCreateRequestModelInput & {
    id?: string;
};
export type ReminderResponseModel = {
    id: string;
    title: string;
    description?: string;
    reminderDate: Date | string;
    status: string;
    type: REMINDER_TYPE;
    objectId?: string;

    objectType?: REMINDER_OBJECT_TYPE;
    userId: string;
};

export const reminderDefaultValues: ReminderCreateUpdateRequestModel = {
    title: '',
    description: '',
    reminderDate: new Date(new Date().getTime() + 15 * 60000),
    status: 'Pending',
    type: REMINDER_TYPE.MANUAL,
    userId: '',
    objectId: '',
    objectType: REMINDER_OBJECT_TYPE.ITEM_DATA,
};

export interface ReminderGetAllRequest
    extends QueryBaseTypeWithCursorPaginationWhereAndOrder<ReminderWhereQueryModel> {}

export interface NearestReminderByObjectIdRequest extends CursorBasedPaginationRequest {
    objectId: string;
    objectType: REMINDER_OBJECT_TYPE;
    currentDate: Date | string;
}

export interface ReminderPaginationResponse {
    reminders: CursorBasedPaginationResponse<ReminderModel>;
}

export interface ReminderUserIdObjectIdPaginationResponse {
    reminders: CursorBasedPaginationResponse<ReminderModel>;
}

export type ReminderWhereQueryModel = {
    active: boolean;
    createdBy: string;
    createdDate: Date;
    description: string;
    id: string;
    isCompleted: boolean;
    lastModifiedDate: Date;
    modifiedBy: string;
    reminderDate: Date;
    status: string;
    title: string;
    objectId: string;
    type: REMINDER_TYPE;
    objectType: REMINDER_OBJECT_TYPE;
    url: string;
    ticketNo: number;
    userId: string;
};
